import { defineComponent, useSlots, computed, createElementBlock, openBlock, createCommentVNode, createElementVNode, createBlock, withCtx, createTextVNode, toDisplayString, createVNode, mergeProps, Fragment, renderList, normalizeClass, renderSlot } from 'vue';
import _sfc_main$2 from './basler-components.es114.js';
/* empty css                        */
import _sfc_main$3 from './basler-components.es70.js';
/* empty css                       */
import _sfc_main$1 from './basler-components.es87.js';
/* empty css                       */
import _sfc_main$4 from './basler-components.es133.js';
import { useSlotContent } from './basler-components.es426.js';

const _hoisted_1 = { class: "product-table-item" };
const _hoisted_2 = {
  key: 0,
  class: "product-table-item__td-media"
};
const _hoisted_3 = { class: "product-table-item__media" };
const _hoisted_4 = {
  key: 2,
  class: "product-table-item__badge"
};
const _hoisted_5 = {
  key: 1,
  class: "product-table-item__td-title"
};
const _hoisted_6 = { class: "product-table-item__headline" };
const _hoisted_7 = { class: "product-table-item__headline-inner" };
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = ["innerHTML"];
const _hoisted_10 = {
  key: 2,
  class: "product-table-item__td-description"
};
const _hoisted_11 = { class: "product-table-item__description-box" };
const _hoisted_12 = { key: 0 };
const _hoisted_13 = ["innerHTML"];
const _hoisted_14 = { key: 1 };
const _hoisted_15 = {
  key: 4,
  class: "product-table-item__td-price"
};
const _hoisted_16 = {
  key: 1,
  class: "product-table-item__price-container"
};
const _hoisted_17 = {
  key: 0,
  class: "product-table-item__price-prefix-box"
};
const _hoisted_18 = { class: "product-table-item__price-prefix" };
const _hoisted_19 = {
  key: 0,
  class: "product-table-item__price-prefix-attention-text"
};
const _hoisted_20 = { class: "product-table-item__price-text-box" };
const _hoisted_21 = {
  key: 0,
  class: "product-table-item__price-text"
};
const _hoisted_22 = {
  key: 1,
  class: "product-table-item__previous-price-text"
};
const _hoisted_23 = {
  key: 5,
  class: "product-table-item__td-cta"
};
const _hoisted_24 = { class: "product-table-item__cta-box" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ProductTableItem",
  props: {
    product: {},
    badgeText: { default: "" },
    badgeStyle: {},
    showAttributes: { type: Boolean, default: true },
    link: {},
    isLoading: { type: Boolean, default: false },
    loadingLines: { default: 3 },
    attributesLoadingLines: { default: 3 },
    isFullsizeImage: { type: Boolean },
    cardDataAttributes: {}
  },
  setup(__props) {
    const slots = useSlots();
    const { hasSlotContent } = useSlotContent();
    const hasCtaSlotContent = computed(() => {
      return hasSlotContent(slots["item-cta"]);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("tr", _hoisted_1, [
        _ctx.product.media ? (openBlock(), createElementBlock("td", _hoisted_2, [
          createElementVNode("div", _hoisted_3, [
            _ctx.isLoading ? (openBlock(), createBlock(_sfc_main$1, {
              key: 0,
              class: "product-table-item__loading-media"
            })) : (openBlock(), createBlock(_sfc_main$2, {
              key: 1,
              media: _ctx.product.media,
              lazyload: true
            }, null, 8, ["media"])),
            _ctx.badgeText ? (openBlock(), createElementBlock("div", _hoisted_4, [
              _ctx.isLoading ? (openBlock(), createBlock(_sfc_main$1, { key: 0 })) : (openBlock(), createBlock(_sfc_main$3, {
                key: 1,
                "badge-style": _ctx.badgeStyle,
                "is-rounded": true,
                "icon-name": "pricetag-alt",
                size: "small",
                "has-shine-animation": true
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(_ctx.badgeText), 1)
                ]),
                _: 1
              }, 8, ["badge-style"]))
            ])) : createCommentVNode("", true)
          ])
        ])) : createCommentVNode("", true),
        _ctx.product.name ? (openBlock(), createElementBlock("td", _hoisted_5, [
          createElementVNode("h3", _hoisted_6, [
            createVNode(_sfc_main$4, mergeProps(_ctx.link, {
              "is-renderless": true,
              class: _ctx.link ? "product-table-item__headline-link" : void 0
            }), {
              default: withCtx(() => [
                createElementVNode("span", _hoisted_7, [
                  _ctx.product.name && _ctx.isLoading ? (openBlock(), createBlock(_sfc_main$1, { key: 0 })) : (openBlock(), createElementBlock("span", {
                    key: 1,
                    class: "product-table-item__headline-part",
                    innerHTML: _ctx.product.name
                  }, null, 8, _hoisted_8)),
                  _ctx.product.variantName && _ctx.isLoading ? (openBlock(), createBlock(_sfc_main$1, { key: 2 })) : (openBlock(), createElementBlock("span", {
                    key: 3,
                    class: "product-table-item__headline-part",
                    innerHTML: _ctx.product.variantName
                  }, null, 8, _hoisted_9))
                ])
              ]),
              _: 1
            }, 16, ["class"])
          ])
        ])) : createCommentVNode("", true),
        _ctx.product.description ? (openBlock(), createElementBlock("td", _hoisted_10, [
          createElementVNode("div", _hoisted_11, [
            _ctx.isLoading ? (openBlock(), createElementBlock("p", _hoisted_12, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.loadingLines, (index) => {
                return openBlock(), createBlock(_sfc_main$1, { key: index });
              }), 128))
            ])) : (openBlock(), createElementBlock("p", {
              key: 1,
              innerHTML: _ctx.product.description
            }, null, 8, _hoisted_13))
          ])
        ])) : createCommentVNode("", true),
        _ctx.showAttributes && Array.isArray(_ctx.product.attributes) && _ctx.product.attributes.length > 0 ? (openBlock(true), createElementBlock(Fragment, { key: 3 }, renderList(_ctx.product.attributes, (attribute) => {
          return openBlock(), createElementBlock("td", {
            key: attribute.key,
            class: normalizeClass(`product-table-item__td-${attribute.key}`)
          }, [
            _ctx.isLoading ? (openBlock(), createBlock(_sfc_main$1, { key: 0 })) : (openBlock(), createElementBlock("span", _hoisted_14, toDisplayString(attribute.value), 1))
          ], 2);
        }), 128)) : createCommentVNode("", true),
        _ctx.product.pricePrefix || _ctx.product.priceText ? (openBlock(), createElementBlock("td", _hoisted_15, [
          _ctx.isLoading ? (openBlock(), createBlock(_sfc_main$1, { key: 0 })) : (openBlock(), createElementBlock("div", _hoisted_16, [
            _ctx.product.pricePrefix ? (openBlock(), createElementBlock("small", _hoisted_17, [
              createElementVNode("span", _hoisted_18, toDisplayString(_ctx.product.pricePrefix), 1),
              _ctx.product.pricePrefixAttentionText ? (openBlock(), createElementBlock("span", _hoisted_19, toDisplayString(_ctx.product.pricePrefixAttentionText), 1)) : createCommentVNode("", true)
            ])) : createCommentVNode("", true),
            createElementVNode("div", _hoisted_20, [
              _ctx.product.priceText ? (openBlock(), createElementBlock("strong", _hoisted_21, toDisplayString(_ctx.product.priceText), 1)) : createCommentVNode("", true),
              _ctx.product.previousPriceText ? (openBlock(), createElementBlock("span", _hoisted_22, toDisplayString(_ctx.product.previousPriceText), 1)) : createCommentVNode("", true)
            ])
          ]))
        ])) : createCommentVNode("", true),
        hasCtaSlotContent.value ? (openBlock(), createElementBlock("td", _hoisted_23, [
          createElementVNode("div", _hoisted_24, [
            renderSlot(_ctx.$slots, "item-cta")
          ])
        ])) : createCommentVNode("", true)
      ]);
    };
  }
});

export { _sfc_main as default };
